import {
  apiGet,
  apiPost,
  apiDelete,
  apiDownload,
  apiPut,
} from '../../api/index';
import { urlMateriasPeriodo } from '../../api/urls';

export function filter({ pageInfo = { page: 1, pageSize: 15 }, onSuccess, onError }) {
  return apiPost(`${urlMateriasPeriodo}/all`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function filterHomework({
  materiaPeriodoId,
  pageInfo = { page: 1, pageSize: 15 },
  onSuccess,
  onError,
}) {
  return apiPost(`${urlMateriasPeriodo}/${materiaPeriodoId}/homework/all`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function filterMyHomework({
  subjectId,
  pageInfo = { page: 1, pageSize: 15 },
  onSuccess,
  onError,
}) {
  return apiPost(`${urlMateriasPeriodo}/${subjectId}/homework/my`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function getHomework({ id, onSuccess, onError }) {
  return apiGet(`${urlMateriasPeriodo}/homework/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}
export function getSurvey({ id, onSuccess, onError }) {
  return apiGet(`${urlMateriasPeriodo}/surveys/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function filterSurvey({
  materiaPeriodoId,
  pageInfo = { page: 1, pageSize: 15 },
  onSuccess,
  onError,
}) {
  return apiPost(`${urlMateriasPeriodo}/${materiaPeriodoId}/surveys/all`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function get({ id, onSuccess, onError }) {
  return apiGet(`${urlMateriasPeriodo}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function getPlanning({
  id, page, onSuccess, onError,
}) {
  return apiGet(`${urlMateriasPeriodo}/planning/${id}/page-${page}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function save(obj, callback) {
  return apiPost(`${urlMateriasPeriodo}`, obj)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function saveHomework({ paylaod, onSuccess, onError }) {
  return apiPost(`${urlMateriasPeriodo}/homework`, paylaod)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function saveSurvey({ paylaod, onSuccess, onError }) {
  const api = paylaod.id
    ? () => apiPut(`${urlMateriasPeriodo}/surveys`, paylaod.id, paylaod)
    : () => apiPost(`${urlMateriasPeriodo}/surveys`, paylaod);

  return api()
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function changeUtilizaPorcentajePesoMateria({ payload, onSuccess, onError }) {
  return apiPut(`${urlMateriasPeriodo}/uses-percent-weight`, payload.id, payload)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }

      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function publishSubject({
  id, subject, onSuccess, onError,
}) {
  return apiPut(`${urlMateriasPeriodo}/publish`, id, subject)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function stampSubject({
  id, subject, onSuccess, onError,
}) {
  return apiPut(`${urlMateriasPeriodo}/stamp`, id, subject)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function updateScoreHomework(scoreStudent, callback) {
  return apiPost(`${urlMateriasPeriodo}/homework/update-score`, scoreStudent)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function savePlanning({
  page, paylaod, onSuccess, onError,
}) {
  return apiPost(`${urlMateriasPeriodo}/planning/${page}`, paylaod)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function fetchPlanningFormData({ onSuccess, onError }) {
  return apiGet(`${urlMateriasPeriodo}/planning/form-data`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function remove(id, callback) {
  return apiDelete(`${urlMateriasPeriodo}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function removeHomework(id, callback) {
  return apiDelete(`${urlMateriasPeriodo}/homework/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function fetchHomeworkFormDatas({ onSuccess, onError }) {
  return apiGet(`${urlMateriasPeriodo}/homework/form_data`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}


export function fetchFormDatas({ mallaId = 0, onSuccess, onError }) {
  return apiGet(`${urlMateriasPeriodo}/form_data/${mallaId}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function fetchSubjectsByMeshId({ meshId, onSuccess, onError }) {
  return apiGet(`${urlMateriasPeriodo}/subjects/${meshId}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function fetchSubjectsScheduleBySubjectPeriodId({
  subjectId, onSuccess, onError,
}) {
  return apiGet(`${urlMateriasPeriodo}/subjects-schedule/${subjectId}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function fetchSubjectsObjectivesBySubjectPeriodId({
  planningId, onSuccess, onError,
}) {
  return apiGet(`${urlMateriasPeriodo}/subjects-objectives/${planningId}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function AllSubjectsDashboardByStudent(params) {
  return apiGet(`${urlMateriasPeriodo}/materias-tablero-alumno`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function getSubjectStudents(params) {
  const filters = params ? params.filters || {} : {};
  return apiPut(`${urlMateriasPeriodo}/alumnos-materia`, params.id, filters)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function downloadSubjectStudents({ id, onSuccess, onError }) {
  return apiDownload(`${urlMateriasPeriodo}/alumnos-materia-download/${id}`)
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Alumnos.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();
      if (onSuccess) onSuccess(blob);
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}


export function downloadSubjectStudentsScore({ id, onSuccess, onError }) {
  return apiDownload(`${urlMateriasPeriodo}/alumnos-materia-notas-download/${id}`)
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Alumnos.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();
      if (onSuccess) onSuccess(blob);
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}
